import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { rawName } from "@utils/helpers";

import PortableText from "@components/portableText";

const CaseDescription = ({ name }: { name: string }) => {
  const { allSanityCases } = useStaticQuery(graphql`
    query {
      allSanityCases {
        nodes {
          slug { current }
          description { _rawPl, _rawEn }
        }
      }
    }
  `);
  const data = allSanityCases.nodes.find(item => item.slug.current === name);

  return <PortableText blocks={data.description[rawName]} />
};

export default CaseDescription;
